<template>
<div class="box">
  <headerComponent></headerComponent>
  <section id="hero" class="mt-4" style="min-height: 494px">
    <div class="container">
      <div class="container">
        <div class="row d-flex">
          <div class="col-lg-12 text order-2 order-lg-1 text-left image">
            <div>
              <h5>1、登录openwrt后台<br></h5>
              <hr>
              <img src="../../../assets/luyouqi/Upgrade1.png" class="img-fluid" alt="">

              <br>
              <h5>2、进入刷机界面<br></h5>
              <hr>
              <img src="../../../assets/luyouqi/Upgrade2.png" class="img-fluid" alt="">

              <br>
              <h5>3、上传刷机包,点击刷写固件<br></h5>
              <hr>
              <div class="alert alert-info" role="alert">
                <p>保留配置无需改动，保持选中状态即可。</p>
                <p>如不保留配置，需重新填写地址、账号、密码等信息。</p>
                <p>刷机包: <a :href="this.common.downHost+'/downloads/openwrt.bin'">点此下载</a></p>
              </div>
              <img src="../../../assets/luyouqi/Upgrade3.png" class="img-fluid" alt="">

              <br>
              <h5>4、刷机，点击执行<br></h5>
              <hr>
              <div class="alert alert-warning" role="alert">
                <p>MD5效验值：<b>a14486ae34b87b115f9a2492514a4bb2</b></p>
                <p>请确认效验值是否正确，如不正确可能会造成刷机失败而无法使用。</p>
              </div>
              <img src="../../../assets/luyouqi/Upgrade4.png" class="img-fluid" alt="">
              <div class="alert alert-info" role="alert">
                <p>等待大约5分钟左右即可重新登录openwrt管理界面。</p>
              </div>

              <br>
              <h5>5、查看版本信息<br></h5>
              <hr>
              <img src="../../../assets/luyouqi/Upgrade5.png" class="img-fluid" alt="">
              <img src="../../../assets/luyouqi/Upgrade5-2.png" class="img-fluid" alt="">
              <div class="alert alert-info" role="alert">
                <p>刷机完成后版本应是1-42，至此刷机完成。</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 order-1 order-lg-2 mt-4 share-img">

          </div>

        </div>
      </div>


    </div>
  </section>
  <footerComponent></footerComponent>
</div>
</template>

<script>
import headerComponent from "@/components/header";
import footerComponent from "@/components/footer"
export default {
  name: "upgradeTutorial",
  components:{headerComponent, footerComponent}
}
</script>

<style scoped>

</style>